<template>
  <div class="audio-view-normal-box">
    <dl>
      <dt>
        <span class="show-flex-box-r">
          <img :src="poster">
        </span>
      </dt>
      <dd class="show-flex-box-c">
        <dl class="center-control-box show-flex-box-c show-flex-center">
          <dt class="show-flex-box-r">
            <play-progress-loading :isPause="isPause"/>
          </dt>
          <dd class="show-flex-box-r">
            <span class="show-flex-box-r show-flex-center"
                  @click.stop="clickControlButton('switchVideo')">
              <em></em>
              <strong>播放视频</strong>
            </span>
          </dd>
        </dl>
        <div class="bottom-control-box show-flex-box-r show-flex-center">
          <ul class="show-flex-box-r">
            <li class="play-pause-button-box" @click.stop="clickControlButton('playPause')">
              <span :class="`status-style-${isPause ? 'play' : 'pause'}`"></span>
            </li>
            <li class="current-time-box">
              <span>{{times}}</span>
            </li>
            <li class="progress-box show-flex-box-r">
              <normal-progress-bar showType="miniDrag"
                                   :progressPoint="progressPoint"
                                   :bannedControl="bannedControl"
                                   @touchInfo="getProgressData"/>
            </li>
            <li class="duration-box">
              <span>{{duration}}</span>
            </li>
          </ul>
        </div>
      </dd>
    </dl>
  </div>
</template>

<script>

// 组件 start
import playProgressLoading from '@/components/video_player/child/play_progress_loading';
import normalProgressBar from '@/components/video_player/child/progress_normal_bar';
// 组件 end

export default {
  props: {
    bannedControl: [Boolean],
    poster: [String],
    isPause: {
      type: Boolean,
      default: true,
    },
    times: [String],
    duration: [String],
    progressPoint: [Number], // 0 - 1
  },
  components: {
    playProgressLoading,
    normalProgressBar
  },
  data(){
    return {
    
    }
  },
  mounted() {
  
  },
  methods: {
    // 进度 start
    getProgressData: function(touchInfo) {
      this.sendProgressStatus(touchInfo);
    },
    // 进度 end
    // 控制按钮 start
    clickControlButton: function(buttonType) {
      if (this.bannedControl) {
        return;
      }

      let clickInfo = {
        buttonType: buttonType,
      };

      this.handleControlInfo(clickInfo);
    },
    handleControlInfo: function(controlInfo) {
      this.sendClickControlInfo(controlInfo);
    },
    // 控制按钮 end
    sendProgressStatus: function(progress) {
      this.$emit('progressChange',progress)
    },
    sendClickControlInfo: function(clickInfo) {
      this.$emit('clickInfo',clickInfo);
    },
  },
};
</script>

<style lang="less">
  .audio-view-normal-box {
    height: 100%;
    &>dl {
      position: relative;
      height: 100%;
      &>dt {
        overflow: hidden;
        width: 100%;
        height: 100%; 
        &>span {
          width: 100%;
          height: 100%; 
          &>img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            -webkit-box-flex: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
            -o-object-fit: cover;
            object-fit: cover;
            -webkit-transform: scale(1.3);
            transform: scale(1.3);
            -webkit-filter: blur(15px);
            -moz-filter: blur(15px);
            -ms-filter: blur(15px);
            -o-filter: blur(15px);
            filter: blur(15px);
          }
        }
      }
      &>dd {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-top: 0.17rem;
        padding-bottom: 0.17rem;
        &>.center-control-box {
          flex-grow: 1;
          &>dt {
            margin-bottom: 0.12rem;
          }
          &>dd {
            &>span {
              height: 0.3rem;
              padding-left: 0.12rem;
              padding-right: 0.12rem;
              border-radius: 0.3rem;
              border: 1px solid #fff;
              background: rgba(0,0,0,0.5);
              &>em {
                display: block;
                width: 0.13rem;
                height: 0.13rem;
                margin-right: 0.03rem;
                background: url('../../../../assets/video/play_icon_1_2.png') center center no-repeat;
                background-size: 100% 100%;
              }
              &>strong {
                display: block;
                font-size: 0.14rem;
                color: #fff;
              }
            }
          }
        }
        &>.bottom-control-box {
          padding-left: 0.45rem;
          padding-right: 0.45rem;
          &>ul {
            flex-grow: 1;
            align-items: center;
            height: 0.3rem;
            padding-left: 0.1rem;
            padding-right: 0.15rem;
            border-radius: 0.3rem;
            background: rgba(255,255,255,0.7);
            &>li {
              flex-shrink: 0;
            }
            &>.play-pause-button-box {
              padding-left: 0.05rem;
              padding-right: 0.05rem;
              &>span {
                display: block;
                width: 0.14rem;
                height: 0.14rem;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center center;
              }
              &>.status-style-play {
                background-image: url('../../../../assets/video/play_icon_1_1.png');
              }
              &>.status-style-pause {
                background-image: url('../../../../assets/video/pause_icon_1_1.png');
              }
            }
            &>.progress-box {
              flex-grow: 1;
              height: 100%;
              align-items: center;
            }
            &>.current-time-box,
            &>.duration-box {
              min-width: 0.4rem;
              padding-left: 0.025rem;
              padding-right: 0.025rem;
              &>span {
                display: block;
                font-size: 0.12rem;
                font-family: PingFangSC-Regular;
                line-height: 0.18rem;
                white-space: nowrap;
                color: #333;
              }
            }
            &>.current-time-box {
              &>span {
                text-align: left;
              }
            }
            &>.duration-box {
              &>span {
                text-align: right;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/view/audio/audio_view_normal.vue